<template>
  <div id="app">
    <header class="primary">
      <div class="firstbar">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <div class="brand">
                <router-link :to="{ name: 'LastArticles' }">
                  <img src="/static/images/logo.jpg"/>
                </router-link>
              </div>
            </div>
            <div class="col-md-9 col-sm-12 text-right">
              <ad format="header"></ad>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section :class="{ home: $route.name !== 'ArticlePage', single: ['ArticlePage', 'PressReleasePage'].indexOf($route.name) !== -1 }">
      <div class="container">
        <div class="row router-view">
          <div class="col-md-8 col-sm-12 col-xs-12">
            <router-view></router-view>
            <div class="banner">
              <ad format="header"></ad>
            </div>
          </div>
          <div class="col-xs-6 col-md-4 sidebar" id="sidebar">
            <div class="sidebar-title for-tablet">Sidebar</div>
            <aside>
              <div class="aside-body">
                <br><br>
                <form class="search" autocomplete="off" @submit.prevent="search">
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text" name="q" class="form-control" placeholder="Recherche" v-model="query">
                      <div class="input-group-btn">
                        <button class="btn btn-primary"><i class="ion-search"></i></button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </aside>
            <aside>
              <div class="aside-body">
                <form class="newsletter" @submit.prevent="subscribeUser">
                  <div class="icon">
                    <i class="ion-ios-email-outline"></i>
                    <h1>S'abonner</h1>
                  </div>
                  <add-subscriber ref="addSubscriber" broadcastChannel="ITRInnovation"></add-subscriber>
                  <div class="input-group">
                    <input type="email" class="form-control email" placeholder="Adresse email" v-model="email">
                    <div class="input-group-btn">
                      <button class="btn btn-primary"><i class="ion-paper-airplane"></i></button>
                    </div>
                  </div>
                  <p>Veuillez renseigner votre email afin de vous abonner à la newsletter.</p>
                  <p class="text-center">
                    <router-link :to="{ name: 'RGPD' }">Voir la politique de confidentialité</router-link>
                  </p>
                </form>
              </div>
            </aside>
            <aside>
              <h1 class="aside-title">Communiqués de presse</h1>
              <div class="aside-body">
                <press-releases :limit="10" :withFile="false">
                  <template slot-scope="props">
                    <div v-for="pressRelease in props.pressReleases">
                      <article class="article-mini">
                        <div class="inner">
                          <div>
                            <h1>
                              <a v-if="pressRelease.fileURL" :href="pressRelease.fileURL" target="_blank">{{ pressRelease.shortTitle }}</a>
                              <router-link v-else :to="{ name: 'PressReleasePage', params: { id: pressRelease.id, slug: pressRelease.slug } }">{{ pressRelease.shortTitle }}</router-link>
                            </h1>
                          </div>
                        </div>
                      </article>
                    </div>
                  </template>
                </press-releases>
              </div>
            </aside>
            <aside>
              <h1 class="aside-title">ITRTV</h1>
              <div class="aside-body">
                <vimeo-videos :per_page="1">
                  <template slot-scope="props">
                    <article class="article-mini" v-for="video in props.videos">
                      <div class="inner">
                        <div>
                          <div v-html="video.iframeCode"></div>
                          <br />
                          <h1><a :href="video.link" target="_blank">{{ video.name }}</a></h1>
                        </div>
                      </div>
                    </article>
                  </template>
                </vimeo-videos>
              </div>
            </aside>
            <aside>
              <ad format="card"></ad>
            </aside>
          </div>
        </div>
      </div>
    </section>

    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="block">
              <h1 class="block-title">Contact</h1>
              <div class="block-body">
                <p class="brand-description">
                  Groupe ITRnews<br/>
                  21 rue Henry Monnier<br/>
                  75009 Paris
                </p>
                <p class="brand-description">
                  <strong>Pour nous contacter :</strong><br />
                  Tél : 01 40 16 10 77
                </p>
                <p class="brand-description">
                  <strong>Publicité</strong><br />
                  T&eacute;l : 01 40 16 18 48<br />
                  Fax : 01 49 95 00 23<br />
                  <a href="mailto:publicite@itrmobiles.com" target="_blank">Contactez nous par mail</a>  </p>
                <p class="brand-description">
                  <strong>Rédaction</strong><br />
                  Tél : 01 40 16 18 55<br />
                  <a href="mailto:redaction@itrmobiles.com" target="_blank">Contactez nous par mail</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="block">
              <h1 class="block-title">Derniers articles</h1>
              <div class="block-body">
                <articles-query :tags="['innov_oid']" :limit="4" :withPagination="false">
                  <template slot-scope="props">
                    <article class="article-mini" v-for="article in props.articles">
                      <div class="inner">
                        <figure v-if="article.featured_img">
                          <a href="#">
                            <img :src="article.featured_img">
                          </a>
                        </figure>
                        <div :class="{ padding: article.featured_img }">
                          <h1><router-link :to="{ name: 'ArticlePage', params: { id: article.oid, slug: article.slug } }">{{ article.title }}</router-link></h1>
                        </div>
                      </div>
                    </article>
                  </template>
                </articles-query>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-xs-12 col-sm-6">
            <div class="block">
              <h1 class="block-title">Partager</h1>
              <div class="block-body">
                <ul class="social trp">
                  <li>
                    <a href="https://www.facebook.com/sharer/sharer.php" class="facebook" target="_blank">
                      <svg><rect width="0" height="0"/></svg>
                      <i class="ion-social-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a :href="`https://twitter.com/home?status=${pageUrl}`" class="twitter" target="_blank">
                      <svg><rect width="0" height="0"/></svg>
                      <i class="ion-social-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a :href="`https://plus.google.com/share?url=${pageUrl}`" class="googleplus" target="_blank">
                      <svg><rect width="0" height="0"/></svg>
                      <i class="ion-social-googleplus"></i>
                    </a>
                  </li>
                  <li>
                    <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" class="linkedin" target="_blank">
                      <svg><rect width="0" height="0"/></svg>
                      <i class="ion-social-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="http://rss.itrinnovation.com" class="rss" target="_blank">
                      <svg><rect width="0" height="0"/></svg>
                      <i class="ion-social-rss"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <br><br>
            <p class="text-center">
              <router-link :to="{ name: 'RGPD' }">Voir la politique de confidentialité</router-link>
            </p>
            <br/>
            <site-footer></site-footer>
            <div class="copyright">
              COPYRIGHT &copy; ITRInnovation 2017. Tous droits réservés.
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { Ad, AddSubscriber, SiteFooter, PressReleases, VimeoVideos, categories, ArticlesQuery } from 'itrnews-vuejs-api';

  export default {
    name: 'app',
    components: { Ad, AddSubscriber, SiteFooter, PressReleases, VimeoVideos, ArticlesQuery },
    mixins: [categories],
    methods: {
      subscribeUser(event) {
        event.preventDefault();
        this.$refs.addSubscriber.sendRequest(this.email);
      },
      search(event) {
        event.preventDefault();
        this.$router.push({ name: 'ArticlesSearch', params: { query: this.query } });
      },
    },
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        email: '',
        pageUrl: '',
        query: '',
      };
    },
  };
</script>

<style>
  header.primary {
    position: relative !important;
  }

  .banner:after {
    content: '- Publicité -' !important;
  }
  .firstbar .brand img {
    width: 300px;
  }
  .btn.btn-default {
    color: black !important;
  }
  .article-mini h1 {
    text-transform: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue